export function getGroupName(groupId: number, groupCount: number) {
    return groupCount > 26
        ? groupId + 1
        : String.fromCharCode('A'.charCodeAt(0) + groupId);
}
